import { useFormik } from "formik";
import { Button, TextInput, KeyIcon, Typography, theme } from "kosmos-ui/lib";

import { useUpdateMyShopperPwMutation } from "api/graphql/mutations/shopper/hooks";
import { ShopperBrowserSection, ShopperBrowserForm } from "../../styles";

import { TUpdateMyShopperPwFormValues } from "./types";
import { shopperPwFormValidationSchema } from "./helpers";
import { NotesContainer } from "app/sections/shopper/ShopperSignUp/styles";

export default function ShopperAccountSection() {
  const [
    updateMyShopperPwMutation,
    { loading: loadingUpdateMyShopperPwMutation },
  ] = useUpdateMyShopperPwMutation();

  const form = useFormik<TUpdateMyShopperPwFormValues>({
    initialValues: {
      currentPw: "",
      newPw: "",
    },
    validationSchema: shopperPwFormValidationSchema,
    onSubmit(values) {
      console.log({ values });

      updateMyShopperPwMutation({
        variables: values,
      });
    },
  });

  return (
    <ShopperBrowserSection style={{ maxWidth: 380 }}>
      <Typography
        as="h1"
        variant="title3"
        style={{ color: theme.colorsPalette.white.default }}
      >
        Contraseña
      </Typography>

      <NotesContainer>
        Tu contraseña debe tener como mínimo 8 caracteres, una mayúscula, un
        número y una minúscula.
      </NotesContainer>

      <ShopperBrowserForm onSubmit={form.handleSubmit} noValidate>
        <TextInput
          name="currentPw"
          value={form.values.currentPw}
          onChange={form.handleChange}
          onBlur={form.handleBlur}
          label="Contraseña actual"
          variant="filled"
          type="password"
          error={!!form.errors.currentPw && form.touched.currentPw}
          adornments={{ left: <KeyIcon height="20px" /> }}
          style={{
            root: { marginBottom: 8 },
            inputContainer: {
              backgroundColor: theme.colorsPalette.black.lighter,
              border: "none",
            },
          }}
        />

        <TextInput
          name="newPw"
          value={form.values.newPw}
          onChange={form.handleChange}
          onBlur={form.handleBlur}
          label="Contraseña nueva"
          variant="filled"
          type="password"
          error={!!form.errors.newPw && form.touched.newPw}
          adornments={{ left: <KeyIcon height="20px" /> }}
          style={{
            inputContainer: {
              backgroundColor: theme.colorsPalette.black.lighter,
              border: "none",
            },
          }}
        />

        <Button
          variant="primary"
          type="submit"
          loading={loadingUpdateMyShopperPwMutation}
          style={{ width: "100%", marginTop: 24 }}
        >
          Guardar cambios
        </Button>
      </ShopperBrowserForm>
    </ShopperBrowserSection>
  );
}
